import { AxiosError } from 'axios';

import { USER_ONLINE_STATUS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

export interface OnlineStatusResponse {
  message: string;
  timestamp?: string;
}

/**
 * Updates the user's online status by calling the backend API
 * The user_id is automatically extracted from the JWT token on the backend
 */
const updateOnlineStatus = async (): Promise<
  ApiResponse<OnlineStatusResponse>
> => {
  try {
    const response = await apiManager.post(USER_ONLINE_STATUS_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default updateOnlineStatus;
